<template>
  <div class="proposeList">
    <!-- <div class="header">
        <img src="@/assets/new/fan.png"  @click="goHome" alt="">
        <span>我的奖励</span>
    </div> -->
    <div class="mone">
      <img :src="avatar" class="tous" alt=""/>
      <span class="hname">Welcome Galmcypro!</span>
    </div>
    <div class="mtwo">
      <!-- @click="setPopup" -->
      <div class="xiaofei">
        <span class="xiao">{{ $t("new.gelei") }}</span>
<!--        <img-->
<!--            src="@/assets/c/icon_wh_hs.png"-->
<!--            class="icon_wh_hs"-->
<!--            alt=""-->
<!--            @click="xfshow = false"-->
<!--        />-->
      </div>
      <span class="qian"
      >$<span class="qnum">{{ self_consumption_show }}</span></span
      >
    </div>
    <div class="mthree">
      <div class="xview" @click.stop="getleitype(1)">
        <div class="gleft">
          <div class="gone">
            <span class="yishi">{{ $t("new.yishione") }}</span>
            <img
                src="@/assets/c/icon_wh_n.png"
                class="icon_wh_n"
                alt=""
            />
          </div>
          <span class="gnum">{{ gmc_balance_show }}</span>
        </div>
        <div class="gti" @click.stop="getti(1)">
          {{ $t("new.tiqu") }}
        </div>
      </div>
      <div
          class="xview xtwo"
          @click.stop="getleitype(2)"
          style="background: rgba(0, 198, 222, 1)"
      >
        <div class="gleft">
          <div class="gone">
            <span class="yishi">{{ $t("new.yishitwo") }}</span>
            <img
                src="@/assets/c/icon_wh_s.png"
                class="icon_wh_n"
                alt=""
            />
          </div>
          <span class="gnum">{{ gmc_balance_lock_show }}</span>
        </div>
        <div class="gti" @click.stop="getti(2)">
          {{ $t("new.shuhui") }}
        </div>
      </div>
      <div
          class="xview"
          @click.stop="getleitype(3)"
          style="background: rgba(231, 231, 231, 1)"
      >
        <div class="gleft">
          <div class="gone">
            <span class="yishi">{{ $t("new.yishithree") }}</span>
            <img
                src="@/assets/c/icon_wh_n.png"
                class="icon_wh_n"
                alt=""
            />
          </div>
          <span class="gnum">{{ node_number_show }}</span>
        </div>
        <div class="gti" @click.stop="getti(3)">
          {{ $t("new.fenjie") }}
        </div>
      </div>
      <div
          class="xview xtwo"
          @click.stop="getleitype(4)"
          style="background: rgba(0, 0, 0, 1)"
      >
        <div class="gleft">
          <div class="gone">
            <span class="yishi">{{ $t("new.yishifour") }}</span>
            <img
                src="@/assets/c/icon_wh_s.png"
                class="icon_wh_n"
                alt=""
            />
          </div>
          <span class="gnum">{{ nft_number_show }}</span>
        </div>
        <div class="gti" @click.stop="getti(4)">
          {{ $t("new.fenjie") }}
        </div>
      </div>
    </div>
    <div class="mgong">
      <span class="gleft">{{ $t("new.gtit") }}</span>
      <div class="gview">
        <img
            src="@/assets/c/icon_bzgxz.png"
            class="icon_bzgxz"
            alt=""
        />
        <span class="gname">{{ $t("new.benzhougx") }}</span>
        <span class="gnum">${{ total_xiaofei_show }}</span>
      </div>
    </div>
    <div class="mthree">
      <!-- 流动性 -->
      <div class="xview xthree">
        <div class="gleft">
          <div class="gone">
            <span class="yishi">{{ $t("new.liudongx") }}</span>
          </div>
          <span class="gnum">{{ mobility_show }}</span>
        </div>
      </div>
      <!-- 持币GMC -->
      <div class="xview xthree">
        <div class="gleft">
          <div class="gone">
            <span class="yishi">{{ $t("new.chibi") }}</span>
          </div>
          <span class="gnum">{{ gmc_balance_all_show }}</span>
        </div>
      </div>
      <!-- 直邀消费额 -->
      <div class="xview xthree">
        <div class="gleft">
          <div class="gone">
            <span class="yishi">{{ $t("new.yiji") }}</span>
          </div>
          <span class="gnum">${{ direct_push_xiaofei_show }}</span>
        </div>
      </div>
      <!-- 间邀消费额 -->
      <div class="xview xthree">
        <div class="gleft">
          <div class="gone">
            <span class="yishi">{{ $t("new.erji") }}</span>
          </div>
          <span class="gnum">${{ jianjie_push_xiaofei_show }}</span>
        </div>
      </div>
    </div>
    <div class="mgong">
      <span class="gleft">{{ $t("new.tjtj") }}</span>
      <div class="mthree">
        <div class="xview xfour">
          <img
              src="@/assets/c/img_wdtj.png"
              class="img_wdtj"
              alt=""
          />
          <div class="ritem">
            <span class="mtui">{{ $t("new.wotui") }}</span>
            <span class="mtum">{{ Number(direct_push_show) }}</span>
          </div>
        </div>
        <div class="xview xfour">
          <img src="@/assets/c/img_td.png" class="img_wdtj" alt=""/>
          <div class="ritem">
            <span class="mtui">{{ $t("new.tuantui") }}</span>
            <span class="mtum">{{ Number(sons_show) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 提取赎回弹窗 -->
    <!-- 价值详情弹窗 -->

    <van-popup
        :close-on-click-overlay="false"
        v-model="tishow"
        position="center"
        :style="{ background: 'none' }"
        :overlay-style="{ background: 'rgba(0, 0, 0, 0.7)' }"
    >
      <div class="van-popview animate__animated animate__zoomIn">
        <div class="jiahead" style="width: 125px">
          <img src="@/assets/c/img_btbj.png" class="bg" alt=""/>
          <div class="jiaview" v-if="type == 1">
            {{ $t("new.tishu") }}
          </div>
          <div class="jiaview" v-else-if="type == 2">
            {{ $t("new.shushu") }}
          </div>
          <div class="jiaview" v-else-if="type == 3">
            {{ $t("new.fenshu") }}
          </div>
          <div class="jiaview" v-else-if="type == 4">
            {{ $t("new.fenshu2") }}
          </div>
        </div>
        <div class="shuviewpop">
                    <span v-if="type == 1" class="snum"
                    ><span class="nums">{{ gmc_balance }}</span
                    >GMC</span
                    >
          <span v-else-if="type == 2" class="snum"
          ><span class="nums">{{ ico_order_gmc }}</span
          >GMC</span
          >
          <span v-else-if="type == 3" class="snum"
          ><span class="nums">{{ discompose_node_gmc }}</span
          >GMC</span
          >
          <span v-else-if="type == 4" class="snum"
          ><span class="nums">{{ discompose_nft_gmc }}</span
          >GMC</span
          >
        </div>
        <div class="qubtn">
          <div class="quleft" @click.stop="hidePopup">
            {{ $t("new.quxiao") }}
          </div>
          <div
              v-if="type == 1"
              class="qudin"
              @click.stop="withdrawalPost"
          >
            {{ $t("new.queren") }}
          </div>
          <div
              v-else-if="type == 2"
              class="qudin"
              @click.stop="icoRedeem"
          >
            {{ $t("new.queren") }}
          </div>
          <div
              v-else-if="type == 3"
              class="qudin"
              @click.stop="nodeBreakdown"
          >
            {{ $t("new.queren") }}
          </div>
          <div
              v-else-if="type == 4"
              class="qudin"
              @click.stop="nftBreakdown"
          >
            {{ $t("new.queren") }}
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 待释放释放弹窗等 -->

    <van-popup
        :close-on-click-overlay="false"
        v-model="yishitwo_show"
        position="center"
        :style="{ background: 'none' }"
        :overlay-style="{ background: 'rgba(0, 0, 0, 0.7)' }"
    >
      <div class="van-popview shipop animate__animated animate__zoomIn">
        <div class="jiahead" style="width: 125px">
          <img src="@/assets/c/img_bkbjs.png" class="bg" alt=""/>
          <div class="jiaview">
            {{ $t("new.record") }}
          </div>
        </div>
        <div class="zhuanview" style="padding-top: 5px">
          <div
              class="zhuanitem"
              v-for="(item, index) in list"
              :key="index"
          >
            <span class="zname">{{ item.created_at }}</span>
            <span class="zbq active">{{ item.status_name }}</span>
            <span class="rval ml" style="color: red">{{
                item.gmc
              }}</span>
          </div>
        </div>
        <div class="qubtn zbtn">
          <div class="qudin" @click.stop="hidePopup">
            {{ $t("new.queren") }}
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 已释放弹窗等 -->
    <van-popup
        :close-on-click-overlay="false"
        v-model="shishow"
        position="center"
        :style="{ background: 'none' }"
        :overlay-style="{ background: 'rgba(0, 0, 0, 0.7)' }"
    >
      <div
          class="van-popview shipop animate__animated animate__zoomIn"
          style="padding: 10px 10px 20px"
      >
        <div class="jiahead" style="width: 125px">
          <img src="@/assets/c/img_bkbjs.png" class="bg" alt=""/>
          <div class="jiaview" v-if="leitype == 1">
            {{ $t("mine.ysfGmc") }}
          </div>
          <div class="jiaview" v-if="leitype == 2">
            {{ $t("mine.dsfGmc") }}
          </div>
          <div class="jiaview" v-if="leitype == 3">
            {{ $t("mine.ycyjd") }}
          </div>
          <div class="jiaview" v-if="leitype == 4">
            {{ $t("mine.ycynft") }}
          </div>
        </div>
        <div class="nft-title-box" v-if="leitype == 4">
          <div class="nft-title-item" style="margin-bottom: 7px">
            <img src="@/assets/c/img_bkbj.png" alt=""/>
            <div>
              {{ $t("mine.All") }}{{ userNft.totalCount || 0 }}
            </div>
          </div>
          <div class="nft-title-item" style="margin-bottom: 7px">
            <img src="@/assets/c/img_bkbj.png" alt=""/>
            <div>
              {{ $t("mine.Creation") }}{{ userNft.csCount || 0 }}
            </div>
          </div>
          <div class="nft-title-item">
            <img src="@/assets/c/img_bkbj.png" alt=""/>
            <div>
              {{ $t("mine.Collect") }}{{ userNft.dcCount || 0 }}
            </div>
          </div>
          <div class="nft-title-item">
            <img src="@/assets/c/img_bkbj.png" alt=""/>
            <div>
              {{ $t("mine.Qualify") }}{{ userNft.xdCount || 0 }}
            </div>
          </div>
        </div>
        <!-- <div class="lhead">
            <div
                v-for="(item, index) in nft_array"
                :key="index"
                class="lhview"
            >
                <img src="@/assets/c/img_bq.png" class="bg" alt="" />
                <div class="lvitem">
                    {{ item.name }}:{{ item.number }}
                </div>
            </div>
        </div> -->
        <div class="shiqie">
          <div
              @click="setQueryInfo(0)"
              class="shiitem"
              :class="type == 0 ? 'sctive' : ''"
          >
            {{ $t("new.quan") }}
          </div>
          <div
              @click="setQueryInfo(1)"
              class="shiitem"
              :class="type == 1 ? 'sctive' : ''"
          >
            {{ $t("new.shou") }}
          </div>
          <div
              @click="setQueryInfo(2)"
              class="shiitem"
              :class="type == 2 ? 'sctive' : ''"
          >
            {{ $t("new.zhichu") }}
          </div>
        </div>
        <div
            class="zhuanview"
            style="max-height: 300px; overflow-y: auto"
        >
          <div
              v-for="(item, index) in list"
              :key="index"
              class="zhuanitem"
          >
            <span class="zname">{{ item.created_at }}</span>
            <span :class="item.value < 0 ? 'zbq' : 'zbq zbqs'">{{
                item.type_name ||
                item.method_name ||
                item.status_name
              }}</span>
            <span
                :class="
                                item.value < 0 ? 'rval ml' : 'ml rval rvals'
                            "
            >{{ item.value || item.price || item.number }}</span
            >
          </div>
        </div>
        <div class="qubtn zbtn">
          <div class="qudin" @click.stop="hidePopup">
            {{ $t("new.queren") }}
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 消费记录弹窗等 -->
    <van-popup
        :close-on-click-overlay="false"
        v-model="xfshow"
        position="center"
        :style="{ background: 'none' }"
        :overlay-style="{ background: 'rgba(0, 0, 0, 0.7)' }"
    >
      <div
          class="van-popview shipop animate__animated animate__zoomIn"
          style="padding: 10px 20px 20px"
      >
        <div class="jiahead" style="width: 125px">
          <img src="@/assets/c/img_bkbjs.png" class="bg" alt=""/>
          <div class="jiaview">
            {{ $t("mine.xfjl") }}
          </div>
        </div>
        <div class="xiaoview" style="padding-right: 4.4vw;">
          <div class="xiaoone">
            {{ $t("new.shijian") }}
          </div>
          <div class="xiaotwo" style="width: 16%;">
            {{ $t("new.leiname") }}
          </div>
          <div class="xiaothree">
            {{ $t("new.jine") }}
          </div>
        </div>
        <div class="zhuanview">
          <div
              class="zhuanitem"
              v-for="(val, key) in comsume_list"
              :key="key"
          >
            <span class="zname xiaoone">{{ val.updated_at }}</span>
            <span class="jiedian xiaotwo">{{ val.type }}</span>
            <span class="jiedian xiaothree">{{ val.amount }}</span>
          </div>
        </div>
        <div class="qubtn zbtn">
          <div class="qudin" @click.stop="xfshow = false">
            {{ $t("new.queren") }}
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {useNumberAnimation, showToast, getToken} from "@/libs/util.js";
import {ajaxData} from "@/api/ajax";

export default {
  data() {
    return {
      queryInfo: {
        // 0:全部，1:收入、2:支出
        type: 0,
      },
      self_consumption: 0,
      self_consumption_show: 0,
      gmc_balance: 0,
      gmc_balance_show: 0,
      gmc_balance_lock: 0,
      gmc_balance_lock_show: 0,
      node_number: 0,
      node_number_show: 0,
      nft_number: 0,
      nft_number_show: 0,
      total_xiaofei: 0,
      total_xiaofei_show: 0,
      direct_push_xiaofei: 0,
      direct_push_xiaofei_show: 0,
      jianjie_push_xiaofei: 0,
      jianjie_push_xiaofei_show: 0,
      gmc_balance_all: 0,
      gmc_balance_all_show: 0,
      direct_push: 0,
      direct_push_show: 0,
      sons: 0,
      sons_show: 0,
      mobility: 0,
      mobility_show: 0,
      discompose_node_gmc: 0,
      discompose_nft_gmc: 0,
      ico_order_gmc: 0,
      leitype: 1, //1已释放 2代释 3已持有节点 4已持有NFT
      log: [],
      ico_order_gmc_list: [],
      node_order: [],
      nft: [],
      nft_array: [],
      comsume_list: [],
      tishow: false,
      yishitwo_show: false,
      type: 1, //1提取 2赎回 3分解

      shishow: false, //释放弹窗

      xfshow: false, //消费记录

      // 分解数量
      fenjie_number: 0,
      fenjieNFT_number: 0,
      type: 0,
      field: "gmc_balance",
      list: [],
      userNft: {},
      avatar: sessionStorage.getItem("avatar")
          ? sessionStorage.getItem("avatar")
          : "",
      withdrawal_open: 0,
      redeem_open: 0,
      break_open: 0,
      transfer_open: 0,
    };
  },
  created() {
    this.getData();
    this.getAvatar();
  },
  watch: {
    self_consumption(newVal) {
      if (newVal >= 0) {
        useNumberAnimation(newVal, (num) => {
          this.self_consumption_show = num ? num.toFixed(2) : 0;
        });
      }
    },
    gmc_balance(newVal) {
      if (newVal >= 0) {
        useNumberAnimation(newVal, (num) => {
          this.gmc_balance_show = num ? num.toFixed(2) : 0;
        });
      }
    },
    gmc_balance_lock(newVal) {
      if (newVal >= 0) {
        useNumberAnimation(newVal, (num) => {
          this.gmc_balance_lock_show = num ? num.toFixed(2) : 0;
        });
      }
    },
    node_number(newVal) {
      if (newVal >= 0) {
        useNumberAnimation(newVal, (num) => {
          this.node_number_show = num ? num.toFixed(0) : 0;
        });
      }
    },
    nft_number(newVal) {
      if (newVal >= 0) {
        useNumberAnimation(newVal, (num) => {
          this.nft_number_show = num ? num.toFixed(0) : 0;
        });
      }
    },
    total_xiaofei(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.total_xiaofei_show = num ? num.toFixed(2) : 0;
        });
      }
    },
    direct_push_xiaofei(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.direct_push_xiaofei_show = num ? num.toFixed(2) : 0;
        });
      }
    },
    jianjie_push_xiaofei(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.jianjie_push_xiaofei_show = num ? num.toFixed(2) : 0;
        });
      }
    },
    gmc_balance_all(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.gmc_balance_all_show = num ? num.toFixed(2) : 0;
        });
      }
    },
    direct_push(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.direct_push_show = num ? num.toFixed(2) : 0;
        });
      }
    },
    sons(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.sons_show = num ? num.toFixed(2) : 0;
        });
      }
    },
    mobility(newVal) {
      if (newVal > 0) {
        useNumberAnimation(newVal, (num) => {
          this.mobility_show = num ? num.toFixed(0) : 0;
        });
      }
    },
  },
  computed: {},
  methods: {
    getData() {
      ajaxData("/user/statistics", {}).then((response) => {
        // 个人累计消费
        this.self_consumption = response.data?.self_consumption;
        // 已释放gmc
        this.gmc_balance = response.data?.gmc_balance;
        // 待释放gmc
        this.gmc_balance_lock = response.data?.gmc_balance_lock;
        // 已持有节点   node_number
        this.node_number = response.data?.node_number;
        // 已持有NFT
        this.nft_number = response.data?.nft_number;
        // 本周贡献值
        this.total_xiaofei = response.data?.total_xiaofei;
        // 直要消费额
        this.direct_push_xiaofei = response.data?.direct_push_xiaofei;
        // 简邀消费额
        this.jianjie_push_xiaofei = response.data?.jianjie_push_xiaofei;
        // 持有GMC
        this.gmc_balance_all = response.data?.gmc_balance_all;
        //我的推荐
        this.direct_push = response.data?.direct_push;
        //团队推荐
        this.sons = response.data?.sons;
        // 流动性
        this.mobility = response.data?.mobility;
        // 个人消费记录
        this.comsume_list = response.data?.comsume_list;
        // 节点分解后的gmc
        this.discompose_node_gmc = response ? response.data?.discompose_node_gmc : 0;
        // nft分解后的gmc数
        this.discompose_nft_gmc = response ? response.data?.discompose_nft_gmc : 0;
        // gmc
        this.ico_order_gmc = response.data?.gmc_balance_lock;

        // this.getUserLog();
        // this.nodeBreakdownGet();
        // this.nftBreakdownGet();
      });
    },
    getUserLog() {
      ajaxData("/user/log/user", this.queryInfo).then((res) => {
        this.log = res.data.log;
      });
    },
    nodeBreakdownGet() {
      ajaxData("/node/breakdown/get", {}).then((res) => {
        this.fenjie_number = res.data.breakdown;
      });
    },
    nftBreakdownGet() {
      ajaxData("/nft/breakdown/get", {}).then((res) => {
        this.fenjieNFT_number = res.data.breakdown;
      });
    },

    goHome() {
      this.$router.go(-1);
    },
    setPopup() {
      this.xfshow = !this.xfshow;
      this.setBodyOverflow(this.xfshow);
    },
    setBodyOverflow(val) {
      if (val) {
        document.body.style.overflow = "hidden"; // 禁止滚动
      } else {
        document.body.style.overflow = "";
      }
    },
    getti(e) {
      if (!getToken()) {
        showToast(this.$t("execute_connect_wallet"));
        return
      }
      if (e == 1) {
        if (this.withdrawal_open !=1) {
          showToast(this.$t("no_open"));
          return
        }
      } else if(e == 2) {
        if (this.redeem_open !=1) {
          showToast(this.$t("no_open"));
          return
        }
      }else {
        if (this.break_open !=1) {
          showToast(this.$t("no_open"));
          return
        }
      }
      this.type = e;
      this.tishow = true;
      this.setBodyOverflow(true);
    },
    withdrawalPost() {
      ajaxData("/withdrawal/post", {}).then((res) => {
        this.hidePopup();
        if (res.code == 0) {
          showToast(this.$t("已成功提交"));
        } else {
          showToast(res.msg);
        }
        this.getData();
      });
    },
    nodeBreakdown() {
      ajaxData("/node/breakdown", {}).then((res) => {
        this.hidePopup();
        if (res.code == 0) {
          showToast(this.$t("已成功提交"));
        } else {
          showToast(res.msg);
        }
        this.getData();
      });
    },
    icoRedeem() {
      ajaxData("/ico/redeem", {}).then((res) => {
        this.hidePopup();
        if (res.code == 0) {
          showToast(this.$t("已成功提交"));
        } else {
          showToast(res.msg);
        }
        this.getData();
      });
    },
    nftBreakdown() {
      ajaxData("/nft/breakdown", {}).then((res) => {
        this.hidePopup();
        if (res.code == 0) {
          showToast(this.$t("已成功提交"));
        } else {
          showToast(res.msg);
        }
        this.getData();
      });
    },

    setQueryInfo(val) {
      this.type = val;
      this.getLogBouns();
      // this.getUserLog();
    },
    async getLogBouns(fieldIndex) {
      let vm = this;
      this.list = [];
      if (fieldIndex) {
        let fieldType = [
          "",
          "gmc_balance",
          "gmc_balance_lock",
          "node_balance",
          "nft_balance",
        ];
        this.field = fieldType[fieldIndex];
      }
      let res = await ajaxData("/user/log/bouns", {
        type: this.type,
        field: this.field,
      });
      if (res.code == 0) {
        this.list.push(...res.data?.log);
      }
    },
    hidePopup() {
      this.xfshow = false;
      this.tishow = false;
      this.yishitwo_show = false;
      this.shishow = false;
      this.setBodyOverflow(false);
    },
    getleitype(e) {
      this.leitype = e;
      this.type = 0;
      this.getLogBouns(this.leitype);
      if (this.leitype == 4) {
        this.getNftData();
      }
      //"type" : "0",         //0  所有， 1收入，  2 支出
      //"field" : "gmc_balance",
      //  gmc_balance  已释放，  gmc_balance_lock  待释放，  node_balance   节点列表，    nft_balance  nft 列表
      this.shishow = true;
      this.setBodyOverflow(true);
    },
    async getNftData() {
      let res = await ajaxData("/user/nft", {});
      if (res.code == 0) {
        this.userNft = res.data;
      }
    },
    getyao() {
      this.$router.push({path: "/Yaoqing"});
    },
    gettuan() {
      this.$router.push({path: "/Team"});
    },
    getAvatar() {
      let vm = this;
      ajaxData("/setting", {key: "default"}).then((response) => {
        this.avatar = response.data?.setting?.avatar;
        this.mobility = parseFloat(response.data?.setting?.mobility);
        this.withdrawal_open = response.data?.setting?.withdrawal_open;
        this.break_open = response.data?.setting?.break_open;
        this.redeem_open = response.data?.setting?.redeem_open;
        sessionStorage.setItem(
            "avatar",
            response.data?.setting?.avatar
        );
      });
    },
  },
};
</script>


<style scoped lang="less">
p {
  margin: 0;
  padding: 0;
}

.proposeList {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background: #fff;
  padding: 20px 15px 70px 15px;

  .mone {
    display: flex;
    flex-direction: row;
    align-items: center;

    .tous {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }

    .hname {
      font-weight: bold;
      font-size: 16px;
      color: #000000;
    }
  }

  .mtwo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px 0;

    .xiaofei {
      display: flex;
      flex-direction: row;

      .xiao {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
      }

      .icon_wh_hs {
        margin-left: 3px;
        width: 10px;
        height: 10px;
        position: relative;
        top: 1px;
      }
    }

    .qian {
      font-weight: bold;
      font-size: 14px;
      color: #1a1a1a;

      .qnum {
        font-size: 30px;
        position: relative;
        top: 4px;
        margin-left: 2px;
      }
    }
  }

  .mthree {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .xview {
      height: 64px;
      width: 49%;
      position: relative;
      background: #d4faff;
      border-radius: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 10px;

      .gleft {
        width: 60%;
        display: flex;
        flex-direction: column;
        padding-left: 12px;

        .gnum {
          font-weight: bold;
          font-size: 14px;
          color: #333333;
        }

        .gone {
          display: flex;
          flex-direction: row;
          position: relative;
          margin-bottom: 4px;

          .yishi {
            font-weight: bold;
            font-size: 10px;
            color: #333333;
          }

          .icon_wh_n {
            width: 8px;
            height: 8px;
            position: relative;
            margin-left: 4px;
            top: 2px;
          }
        }
      }

      .gti {
        margin-left: auto;
        margin-right: 12px;
        min-width: 45px;
        // height: 18px;
        padding: 2px 6px;
        border-radius: 20px;
        border: 1px solid #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 10px;
        color: #111111;
        box-sizing: border-box;
      }
    }

    .xtwo {
      .gleft {
        .gone {
          .yishi {
            color: #fff;
          }
        }

        .gnum {
          color: #fff;
        }
      }

      .gti {
        color: #fff;
        border: 1px solid #ffffff;
      }
    }

    .xview:nth-child(even) {
      margin-left: auto;
    }

    .xthree {
      background: rgba(242, 245, 250, 1);

      .gleft {
        width: 100%;

        .gone {
          .yishi {
            font-weight: 500;
            font-size: 12px;
            color: #666666;
          }
        }

        .gnum {
          font-weight: 500;
          font-size: 16px;
          color: #000000;
        }
      }
    }

    .xfour {
      background: rgba(242, 245, 250, 1);
      padding: 15px 35px 15px 15px;
      height: auto;

      .img_wdtj {
        width: 40px;
        height: 40px;
      }

      .ritem {
        margin-left: auto;
        display: flex;
        flex-direction: column;

        .mtui {
          font-weight: 500;
          font-size: 10px;
          color: #666666;
        }

        .mtum {
          font-weight: 500;
          font-size: 16px;
          color: #000000;
        }
      }
    }
  }

  .mgong {
    display: flex;
    flex-direction: column;
    margin-top: 12px;

    .gleft {
      font-weight: bold;
      font-size: 15px;
      color: #1a1a1a;
      margin-bottom: 15px;
    }

    .gview {
      height: 40px;
      background: #26e7fe;
      border-radius: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 10px;
      margin-bottom: 15px;

      .icon_bzgxz {
        width: 26px;
        height: 26px;
        margin-right: 10px;
      }

      .gname {
        font-weight: bold;
        font-size: 14px;
        color: #1a1a1a;
      }

      .gnum {
        margin-left: auto;
        font-weight: bold;
        font-size: 14px;
        color: #1a1a1a;
      }
    }
  }

  .tji {
  }

  .header {
    height: 50px;
    // margin-bottom: 12px;
    // padding: 40px 12px 0 12px;
    padding: 6px;
    box-sizing: border-box;
    background: rgba(52, 56, 75, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    width: 100%;
    z-index: 10;
    top: 0;

    img {
      width: 55px;
      height: 55px;
      position: absolute;
      left: 10px;
    }

    span {
      font-weight: bold;
      font-size: 18px;
      color: #ffffff;
    }
  }

  .mhead {
    // position: relative;
    // top: 50px;
  }
}

.shuviewpop {
  display: flex;
  flex-direction: row;
  justify-content: center;

  .snum {
    font-weight: bold;
    font-size: 13px;
    color: #1a1a1a;
    display: block;
    text-align: center;
    margin: 20px 0 50px;

    .nums {
      font-size: 30px;
    }
  }
}

.qubtn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .quleft {
    width: 48%;
    height: 44px;
    background: #f2f5fa;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    color: #111111;
  }

  .qudin {
    width: 48%;
    height: 44px;
    background: rgba(38, 231, 254, 1);
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    color: rgba(26, 26, 26, 1);
  }
}

.shipop {
  border: 1px solid #26e7fe;
}

.shiqie {
  display: flex;
  flex-direction: row;
  height: 44px;
  background: #eeeeee;
  border-radius: 22px;
  margin: 9px 0 15px;

  .shiitem {
    width: 33.33%;
    height: 100%;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }

  .sctive {
    background: #26e7fe;
    color: rgba(0, 0, 0, 1);
  }
}

.nft-title-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin: 10px 20px 0;

  .nft-title-item {
    position: relative;
    width: 90px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;

    > img {
      width: 90px;
      height: 26px;
      position: absolute;
      z-index: 1;
    }

    > div {
      position: relative;
      z-index: 2;
      color: #111111;
      font-size: 13px;
    }
  }
}

.lhead {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  // margin-top: 10px;

  .lhview {
    width: 79px;
    height: 23px;
    position: relative;
    margin: 0 20px 7px;

    .lvitem {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 12px;
      color: #111111;
    }
  }
}

.zhuanview {
  display: flex;
  flex-direction: column;
  height: 224px;
  overflow: scroll;

  .zhuanitem {
    background: #f2f5fa;
    border-radius: 10px;
    padding: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 5px;

    .zname {
      font-weight: 500;
      font-size: 12px;
      color: #666666;
    }

    .zbq {
      padding: 2px 3px;
      background: #666666;
      border-radius: 3px;
      font-weight: 400;
      font-size: 9px;
      display: inline-block;
      margin-left: 3px;
      color: #ffffff;
    }

    .zbqs {
      background: #26e7fe;
      color: #ffffff;
    }

    .active {
      background: #26e7fe;
      color: #fff;
    }

    .ml {
      margin-left: auto;
    }

    .rval {
      font-weight: bold;
      font-size: 12px;
      color: #666666;
    }

    .rvals {
      color: #26e7fe;
    }
  }
}

.zbtn {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  .qudin {
    width: 150px;
    height: 34px;
    background: #26e7fe;
    border-radius: 17px;
  }
}

.xiaoview {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 10px;
  margin-top: 20px;
}

.xiaoone {
  width: 56%;
}

.xiaotwo {
  width: 30%;
  text-align: center;
}

.xiaothree {
  width: 30%;
  text-align: right;
}

.jiedian {
  font-weight: 500;
  font-size: 12px;
  color: #666666;
}

.ncai {
  color: #26e7fe;
}

.popview {
  position: relative;
  width: 330px;
  // height: 300px;
  // background: #34384b;
  border-radius: 15px;
  padding: 30px 30px 20px;

  .chengone {
    width: 100%;
    height: 34px;
    background: #272b3f;
    box-shadow: 0px 1.5px 17px 0px rgba(4, 0, 0, 0.21);
    border-radius: 17px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;

    .icon_cn {
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }

    .chname {
      font-weight: bold;
      font-size: 14px;
      color: #ffffff;
    }
  }

  .jieview {
    border-bottom: 0.5px solid rgba(193, 195, 205, 1);
    padding-bottom: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 20px;

    .juanname {
      font-weight: 500;
      font-size: 14px;
      color: #cccccc;
    }

    .ml {
      margin-left: auto;
    }

    .juaninput {
      font-weight: 400;
      font-size: 14px;
      color: #fff;
      // margin-left: auto;
      text-align: right;
      // width: 86px;
      border: none;
      width: 50%;

      background: transparent;
    }

    .mltwo {
      margin-left: 5px;
    }
  }

  .flcol {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border-bottom: none;
    margin-top: 0px;
    margin-bottom: 20px;

    .yaoma {
      background: rgba(38, 42, 61, 1);
      height: 44px;
      display: flex;
      flex-direction: row;
      align-items: center;
      box-shadow: 0px 2px 17px 0px rgba(4, 0, 0, 0.21);
      border-radius: 5px;
      width: 100%;
      padding: 0 20px;
      margin-top: 10px;

      .juaninputnew {
        font-weight: 400;
        font-size: 14px;
        color: #fff;
        // margin-left: auto;
        text-align: left;
        // width: 86px;
        border: none;
        width: 100%;

        background: transparent;
      }
    }
  }
}

.van-popview {
  position: relative;
  width: 330px;
  background: #ffffff;
  border-radius: 15px;
  border: 1px solid #26e7fe;
  padding: 10px 30px 20px;

  .jiahead {
    width: 104px;
    height: 37px;
    position: relative;
    margin: 0 auto;

    .jiaview {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 15px;
      color: #1a1a1a;
    }
  }

  .zhixiao {
    margin-top: 150px;
    width: 100%;
    height: 44px;
    background: #26e7fe;
    border-radius: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 14px;
    color: #1a1a1a;
  }
}
</style>
